import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {CatalogService} from '../catalog.service';
import {NotificationService} from 'app/core/services/notification.service';
import {ConfigService} from 'app/core/services/config.service';
import {AmberApi} from 'app/core/models/api-helpers';
import {RxComponent} from 'app/core/components/common/rx.component';

@Component({
    selector: 'itpx-catalog-edit',
    templateUrl: './catalog-edit.component.html',
    styleUrls: ['./catalog-edit.component.css']
})
export class CatalogEditComponent extends RxComponent implements OnInit {


    private id: string;
    form: FormGroup;
    domainOptions$: Observable<any[]>;
    readonly domainSpecificOptions = [{key: false, value: 'Marketplace'}, {key: true, value: 'Domain Specific'}];
    readonly onlineOptions = [{key: true, value: 'Online'}, {key: false, value: 'Offline'}];

    constructor(
        private fb: FormBuilder,
        private service: CatalogService,
        private configService: ConfigService,
        private notificationService: NotificationService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        super();
    }

    ngOnInit() {
        this.form = this.fb.group({
            id: [null, Validators.required],
            name: [null, Validators.required],
            code: [null, Validators.required],
            keywords: [],
            domainSpecific: [null, Validators.required],
            online: [null, Validators.required],
            buyerDomains: [null, Validators.required],
            sellerDomains: [null, Validators.required],
            catalogSvg: [null]
        })

        this.route.params.subscribe(params => {
            this.id = params['id'];
            this.service.getCatalogDetails(this.id)
                .subscribe(
                    data => {
                        this.form.patchValue({
                            id: data.id,
                            name: data.name,
                            code: data.code,
                            keywords: data.keywords || [],
                            domainSpecific: data.domainSpecific,
                            online: data.online,
                            buyerDomains: data.buyerDomains ? data.buyerDomains.map(domain => domain.id) : [],
                            sellerDomains: data.sellerDomains ? data.sellerDomains.map(domain => domain.id) : [],
                            catalogSvg: data.catalogSvg
                        })
                        if (data.lmsCatalog) {
                            this.form.get('domainSpecific').disable({onlySelf: true, emitEvent: false});
                        }
                    }
                );
        })
        this.form.get('domainSpecific').valueChanges.bindToLifecycle(this).subscribe(domainSpecific => {
            if (domainSpecific) {
                this.form.get('buyerDomains').enable({onlySelf: true, emitEvent: false});
                this.form.get('sellerDomains').enable({onlySelf: true, emitEvent: false});
            } else {
                this.form.get('buyerDomains').disable({onlySelf: true, emitEvent: false});
                this.form.get('sellerDomains').disable({onlySelf: true, emitEvent: false});
            }
        });
        this.domainOptions$ = this.service.getDomainDict({'@b2b': true}).extract(AmberApi.Data);
    }

    onSubmit(event: any) {
        let form = this.form.value;
        if (form.buyerDomains) {
            form.buyerDomains = form.buyerDomains.map(id => ({id: id}));
        }
        if (form.sellerDomains) {
            form.sellerDomains = form.sellerDomains.map(id => ({id: id}));
        }
        this.service.edit(form)
            .subscribe(
                data => {
                    this.notificationService.success('Successfully created a template', 'Success');
                    this.router.navigate(['/agora/product-data/catalogs/:id/details', {id: this.id}]);
                },
                error => {
                }
            )
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/catalogs/edit/catalog-edit.component.ts